export const validateClash = (clash: boolean) =>
  clash ? "Field names must be unique." : null;
